import {CookieConsent} from '@/shared/lib/localStorage/signUp/cookieConsent';

import {INITIAL_MODAL_PREFERENCES} from '../consts';
import {CookiePreferences} from '../types';

export function getCookiePreferences(
  consent: CookieConsent | null
): CookiePreferences {
  if (!consent) {
    return INITIAL_MODAL_PREFERENCES;
  }

  return {
    statistics: consent.categories.statistics,
    marketing: consent.categories.marketing,
  };
}
